import {
  Dispatch,
  ReactNode,
  createContext,
  useContext,
  useReducer,
} from "react"
import { initialState, reducer } from "../state/sectionReducer"
import { Action, SectionState } from "../types/SectionState"

type Props = {
  children: ReactNode
  passedState?: SectionState
}

const SectionDispatchContext = createContext<Dispatch<Action> | undefined>(
  undefined,
)

const SectionStateContext = createContext(initialState)

const SectionContextProvider = ({ children, passedState }: Props) => {
  const [state, dispatch] = useReducer(reducer, passedState ?? initialState)

  return (
    <SectionStateContext.Provider value={state}>
      <SectionDispatchContext.Provider value={dispatch}>
        {children}
      </SectionDispatchContext.Provider>
    </SectionStateContext.Provider>
  )
}

const useSectionDispatch = () => {
  const context = useContext(SectionDispatchContext)
  if (context === undefined) {
    throw new Error(
      "useSectionDispatch must be used within an SectionContextProvider",
    )
  }
  return context
}

const useSectionState = () => {
  const context = useContext(SectionStateContext)
  if (context === undefined) {
    throw new Error(
      "useAccoutState must be used within an SectionContextProvider",
    )
  }
  return context
}

export { SectionContextProvider, useSectionDispatch, useSectionState }
